import React, { useState, useRef, useEffect } from "react";
import "../styles/Auth.css";
import logo from '../assets/images/logo.png';

const Register = () => {
  const [formData, setFormData] = useState({
    referralId: "",
    name: "",
    mobileNumber: "",
    email: "",
    password: "",
    confirmPassword: "",
    country: ""
  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [registeredUser, setRegisteredUser] = useState(null);
  const [copySuccess, setCopySuccess] = useState(false);
  const [apiError, setApiError] = useState("");
  const [sponsorDetails, setSponsorDetails] = useState(null);
  const [isLoadingSponsor, setIsLoadingSponsor] = useState(false);
  const dropdownRef = useRef(null);

  // Complete countries list with flag image URLs
  const countries = [
    { code: "AF", name: "Afghanistan", flag: "https://flagcdn.com/af.svg", dialCode: "+93" },
    { code: "AL", name: "Albania", flag: "https://flagcdn.com/al.svg", dialCode: "+355" },
    { code: "DZ", name: "Algeria", flag: "https://flagcdn.com/dz.svg", dialCode: "+213" },
    { code: "AD", name: "Andorra", flag: "https://flagcdn.com/ad.svg", dialCode: "+376" },
    { code: "AO", name: "Angola", flag: "https://flagcdn.com/ao.svg", dialCode: "+244" },
    { code: "AG", name: "Antigua and Barbuda", flag: "https://flagcdn.com/ag.svg", dialCode: "+1" },
    { code: "AR", name: "Argentina", flag: "https://flagcdn.com/ar.svg", dialCode: "+54" },
    { code: "AM", name: "Armenia", flag: "https://flagcdn.com/am.svg", dialCode: "+374" },
    { code: "AU", name: "Australia", flag: "https://flagcdn.com/au.svg", dialCode: "+61" },
    { code: "AT", name: "Austria", flag: "https://flagcdn.com/at.svg", dialCode: "+43" },
    { code: "AZ", name: "Azerbaijan", flag: "https://flagcdn.com/az.svg", dialCode: "+994" },
    { code: "BS", name: "Bahamas", flag: "https://flagcdn.com/bs.svg", dialCode: "+1" },
    { code: "BH", name: "Bahrain", flag: "https://flagcdn.com/bh.svg", dialCode: "+973" },
    { code: "BD", name: "Bangladesh", flag: "https://flagcdn.com/bd.svg", dialCode: "+880" },
    { code: "BB", name: "Barbados", flag: "https://flagcdn.com/bb.svg", dialCode: "+1" },
    { code: "BY", name: "Belarus", flag: "https://flagcdn.com/by.svg", dialCode: "+375" },
    { code: "BE", name: "Belgium", flag: "https://flagcdn.com/be.svg", dialCode: "+32" },
    { code: "BZ", name: "Belize", flag: "https://flagcdn.com/bz.svg", dialCode: "+501" },
    { code: "BJ", name: "Benin", flag: "https://flagcdn.com/bj.svg", dialCode: "+229" },
    { code: "BT", name: "Bhutan", flag: "https://flagcdn.com/bt.svg", dialCode: "+975" },
    { code: "BO", name: "Bolivia", flag: "https://flagcdn.com/bo.svg", dialCode: "+591" },
    { code: "BA", name: "Bosnia and Herzegovina", flag: "https://flagcdn.com/ba.svg", dialCode: "+387" },
    { code: "BW", name: "Botswana", flag: "https://flagcdn.com/bw.svg", dialCode: "+267" },
    { code: "BR", name: "Brazil", flag: "https://flagcdn.com/br.svg", dialCode: "+55" },
    { code: "BN", name: "Brunei", flag: "https://flagcdn.com/bn.svg", dialCode: "+673" },
    { code: "BG", name: "Bulgaria", flag: "https://flagcdn.com/bg.svg", dialCode: "+359" },
    { code: "BF", name: "Burkina Faso", flag: "https://flagcdn.com/bf.svg", dialCode: "+226" },
    { code: "BI", name: "Burundi", flag: "https://flagcdn.com/bi.svg", dialCode: "+257" },
    { code: "KH", name: "Cambodia", flag: "https://flagcdn.com/kh.svg", dialCode: "+855" },
    { code: "CM", name: "Cameroon", flag: "https://flagcdn.com/cm.svg", dialCode: "+237" },
    { code: "CA", name: "Canada", flag: "https://flagcdn.com/ca.svg", dialCode: "+1" },
    { code: "CV", name: "Cape Verde", flag: "https://flagcdn.com/cv.svg", dialCode: "+238" },
    { code: "CF", name: "Central African Republic", flag: "https://flagcdn.com/cf.svg", dialCode: "+236" },
    { code: "TD", name: "Chad", flag: "https://flagcdn.com/td.svg", dialCode: "+235" },
    { code: "CL", name: "Chile", flag: "https://flagcdn.com/cl.svg", dialCode: "+56" },
    { code: "CN", name: "China", flag: "https://flagcdn.com/cn.svg", dialCode: "+86" },
    { code: "CO", name: "Colombia", flag: "https://flagcdn.com/co.svg", dialCode: "+57" },
    { code: "KM", name: "Comoros", flag: "https://flagcdn.com/km.svg", dialCode: "+269" },
    { code: "CG", name: "Congo", flag: "https://flagcdn.com/cg.svg", dialCode: "+242" },
    { code: "CR", name: "Costa Rica", flag: "https://flagcdn.com/cr.svg", dialCode: "+506" },
    { code: "HR", name: "Croatia", flag: "https://flagcdn.com/hr.svg", dialCode: "+385" },
    { code: "CU", name: "Cuba", flag: "https://flagcdn.com/cu.svg", dialCode: "+53" },
    { code: "CY", name: "Cyprus", flag: "https://flagcdn.com/cy.svg", dialCode: "+357" },
    { code: "CZ", name: "Czech Republic", flag: "https://flagcdn.com/cz.svg", dialCode: "+420" },
    { code: "DK", name: "Denmark", flag: "https://flagcdn.com/dk.svg", dialCode: "+45" },
    { code: "DJ", name: "Djibouti", flag: "https://flagcdn.com/dj.svg", dialCode: "+253" },
    { code: "DM", name: "Dominica", flag: "https://flagcdn.com/dm.svg", dialCode: "+1" },
    { code: "DO", name: "Dominican Republic", flag: "https://flagcdn.com/do.svg", dialCode: "+1" },
    { code: "EC", name: "Ecuador", flag: "https://flagcdn.com/ec.svg", dialCode: "+593" },
    { code: "EG", name: "Egypt", flag: "https://flagcdn.com/eg.svg", dialCode: "+20" },
    { code: "SV", name: "El Salvador", flag: "https://flagcdn.com/sv.svg", dialCode: "+503" },
    { code: "GQ", name: "Equatorial Guinea", flag: "https://flagcdn.com/gq.svg", dialCode: "+240" },
    { code: "ER", name: "Eritrea", flag: "https://flagcdn.com/er.svg", dialCode: "+291" },
    { code: "EE", name: "Estonia", flag: "https://flagcdn.com/ee.svg", dialCode: "+372" },
    { code: "SZ", name: "Eswatini", flag: "https://flagcdn.com/sz.svg", dialCode: "+268" },
    { code: "ET", name: "Ethiopia", flag: "https://flagcdn.com/et.svg", dialCode: "+251" },
    { code: "FJ", name: "Fiji", flag: "https://flagcdn.com/fj.svg", dialCode: "+679" },
    { code: "FI", name: "Finland", flag: "https://flagcdn.com/fi.svg", dialCode: "+358" },
    { code: "FR", name: "France", flag: "https://flagcdn.com/fr.svg", dialCode: "+33" },
    { code: "GA", name: "Gabon", flag: "https://flagcdn.com/ga.svg", dialCode: "+241" },
    { code: "GM", name: "Gambia", flag: "https://flagcdn.com/gm.svg", dialCode: "+220" },
    { code: "GE", name: "Georgia", flag: "https://flagcdn.com/ge.svg", dialCode: "+995" },
    { code: "DE", name: "Germany", flag: "https://flagcdn.com/de.svg", dialCode: "+49" },
    { code: "GH", name: "Ghana", flag: "https://flagcdn.com/gh.svg", dialCode: "+233" },
    { code: "GR", name: "Greece", flag: "https://flagcdn.com/gr.svg", dialCode: "+30" },
    { code: "GD", name: "Grenada", flag: "https://flagcdn.com/gd.svg", dialCode: "+1" },
    { code: "GT", name: "Guatemala", flag: "https://flagcdn.com/gt.svg", dialCode: "+502" },
    { code: "GN", name: "Guinea", flag: "https://flagcdn.com/gn.svg", dialCode: "+224" },
    { code: "GW", name: "Guinea-Bissau", flag: "https://flagcdn.com/gw.svg", dialCode: "+245" },
    { code: "GY", name: "Guyana", flag: "https://flagcdn.com/gy.svg", dialCode: "+592" },
    { code: "HT", name: "Haiti", flag: "https://flagcdn.com/ht.svg", dialCode: "+509" },
    { code: "HN", name: "Honduras", flag: "https://flagcdn.com/hn.svg", dialCode: "+504" },
    { code: "HU", name: "Hungary", flag: "https://flagcdn.com/hu.svg", dialCode: "+36" },
    { code: "IS", name: "Iceland", flag: "https://flagcdn.com/is.svg", dialCode: "+354" },
    { code: "IN", name: "India", flag: "https://flagcdn.com/in.svg", dialCode: "+91" },
    { code: "ID", name: "Indonesia", flag: "https://flagcdn.com/id.svg", dialCode: "+62" },
    { code: "IR", name: "Iran", flag: "https://flagcdn.com/ir.svg", dialCode: "+98" },
    { code: "IQ", name: "Iraq", flag: "https://flagcdn.com/iq.svg", dialCode: "+964" },
    { code: "IE", name: "Ireland", flag: "https://flagcdn.com/ie.svg", dialCode: "+353" },
    { code: "IL", name: "Israel", flag: "https://flagcdn.com/il.svg", dialCode: "+972" },
    { code: "IT", name: "Italy", flag: "https://flagcdn.com/it.svg", dialCode: "+39" },
    { code: "JM", name: "Jamaica", flag: "https://flagcdn.com/jm.svg", dialCode: "+1" },
    { code: "JP", name: "Japan", flag: "https://flagcdn.com/jp.svg", dialCode: "+81" },
    { code: "JO", name: "Jordan", flag: "https://flagcdn.com/jo.svg", dialCode: "+962" },
    { code: "KZ", name: "Kazakhstan", flag: "https://flagcdn.com/kz.svg", dialCode: "+7" },
    { code: "KE", name: "Kenya", flag: "https://flagcdn.com/ke.svg", dialCode: "+254" },
    { code: "KI", name: "Kiribati", flag: "https://flagcdn.com/ki.svg", dialCode: "+686" },
    { code: "KP", name: "North Korea", flag: "https://flagcdn.com/kp.svg", dialCode: "+850" },
    { code: "KR", name: "South Korea", flag: "https://flagcdn.com/kr.svg", dialCode: "+82" },
    { code: "KW", name: "Kuwait", flag: "https://flagcdn.com/kw.svg", dialCode: "+965" },
    { code: "KG", name: "Kyrgyzstan", flag: "https://flagcdn.com/kg.svg", dialCode: "+996" },
    { code: "LA", name: "Laos", flag: "https://flagcdn.com/la.svg", dialCode: "+856" },
    { code: "LV", name: "Latvia", flag: "https://flagcdn.com/lv.svg", dialCode: "+371" },
    { code: "LB", name: "Lebanon", flag: "https://flagcdn.com/lb.svg", dialCode: "+961" },
    { code: "LS", name: "Lesotho", flag: "https://flagcdn.com/ls.svg", dialCode: "+266" },
    { code: "LR", name: "Liberia", flag: "https://flagcdn.com/lr.svg", dialCode: "+231" },
    { code: "LY", name: "Libya", flag: "https://flagcdn.com/ly.svg", dialCode: "+218" },
    { code: "LI", name: "Liechtenstein", flag: "https://flagcdn.com/li.svg", dialCode: "+423" },
    { code: "LT", name: "Lithuania", flag: "https://flagcdn.com/lt.svg", dialCode: "+370" },
    { code: "LU", name: "Luxembourg", flag: "https://flagcdn.com/lu.svg", dialCode: "+352" },
    { code: "MG", name: "Madagascar", flag: "https://flagcdn.com/mg.svg", dialCode: "+261" },
    { code: "MW", name: "Malawi", flag: "https://flagcdn.com/mw.svg", dialCode: "+265" },
    { code: "MY", name: "Malaysia", flag: "https://flagcdn.com/my.svg", dialCode: "+60" },
    { code: "MV", name: "Maldives", flag: "https://flagcdn.com/mv.svg", dialCode: "+960" },
    { code: "ML", name: "Mali", flag: "https://flagcdn.com/ml.svg", dialCode: "+223" },
    { code: "MT", name: "Malta", flag: "https://flagcdn.com/mt.svg", dialCode: "+356" },
    { code: "MH", name: "Marshall Islands", flag: "https://flagcdn.com/mh.svg", dialCode: "+692" },
    { code: "MR", name: "Mauritania", flag: "https://flagcdn.com/mr.svg", dialCode: "+222" },
    { code: "MU", name: "Mauritius", flag: "https://flagcdn.com/mu.svg", dialCode: "+230" },
    { code: "MX", name: "Mexico", flag: "https://flagcdn.com/mx.svg", dialCode: "+52" },
    { code: "FM", name: "Micronesia", flag: "https://flagcdn.com/fm.svg", dialCode: "+691" },
    { code: "MD", name: "Moldova", flag: "https://flagcdn.com/md.svg", dialCode: "+373" },
    { code: "MC", name: "Monaco", flag: "https://flagcdn.com/mc.svg", dialCode: "+377" },
    { code: "MN", name: "Mongolia", flag: "https://flagcdn.com/mn.svg", dialCode: "+976" },
    { code: "ME", name: "Montenegro", flag: "https://flagcdn.com/me.svg", dialCode: "+382" },
    { code: "MA", name: "Morocco", flag: "https://flagcdn.com/ma.svg", dialCode: "+212" },
    { code: "MZ", name: "Mozambique", flag: "https://flagcdn.com/mz.svg", dialCode: "+258" },
    { code: "MM", name: "Myanmar", flag: "https://flagcdn.com/mm.svg", dialCode: "+95" },
    { code: "NA", name: "Namibia", flag: "https://flagcdn.com/na.svg", dialCode: "+264" },
    { code: "NR", name: "Nauru", flag: "https://flagcdn.com/nr.svg", dialCode: "+674" },
    { code: "NP", name: "Nepal", flag: "https://flagcdn.com/np.svg", dialCode: "+977" },
    { code: "NL", name: "Netherlands", flag: "https://flagcdn.com/nl.svg", dialCode: "+31" },
    { code: "NZ", name: "New Zealand", flag: "https://flagcdn.com/nz.svg", dialCode: "+64" },
    { code: "NI", name: "Nicaragua", flag: "https://flagcdn.com/ni.svg", dialCode: "+505" },
    { code: "NE", name: "Niger", flag: "https://flagcdn.com/ne.svg", dialCode: "+227" },
    { code: "NG", name: "Nigeria", flag: "https://flagcdn.com/ng.svg", dialCode: "+234" },
    { code: "NO", name: "Norway", flag: "https://flagcdn.com/no.svg", dialCode: "+47" },
    { code: "OM", name: "Oman", flag: "https://flagcdn.com/om.svg", dialCode: "+968" },
    { code: "PK", name: "Pakistan", flag: "https://flagcdn.com/pk.svg", dialCode: "+92" },
    { code: "PW", name: "Palau", flag: "https://flagcdn.com/pw.svg", dialCode: "+680" },
    { code: "PS", name: "Palestine", flag: "https://flagcdn.com/ps.svg", dialCode: "+970" },
    { code: "PA", name: "Panama", flag: "https://flagcdn.com/pa.svg", dialCode: "+507" },
    { code: "PG", name: "Papua New Guinea", flag: "https://flagcdn.com/pg.svg", dialCode: "+675" },
    { code: "PY", name: "Paraguay", flag: "https://flagcdn.com/py.svg", dialCode: "+595" },
    { code: "PE", name: "Peru", flag: "https://flagcdn.com/pe.svg", dialCode: "+51" },
    { code: "PH", name: "Philippines", flag: "https://flagcdn.com/ph.svg", dialCode: "+63" },
    { code: "PL", name: "Poland", flag: "https://flagcdn.com/pl.svg", dialCode: "+48" },
    { code: "PT", name: "Portugal", flag: "https://flagcdn.com/pt.svg", dialCode: "+351" },
    { code: "QA", name: "Qatar", flag: "https://flagcdn.com/qa.svg", dialCode: "+974" },
    { code: "RO", name: "Romania", flag: "https://flagcdn.com/ro.svg", dialCode: "+40" },
    { code: "RU", name: "Russia", flag: "https://flagcdn.com/ru.svg", dialCode: "+7" },
    { code: "RW", name: "Rwanda", flag: "https://flagcdn.com/rw.svg", dialCode: "+250" },
    { code: "KN", name: "Saint Kitts and Nevis", flag: "https://flagcdn.com/kn.svg", dialCode: "+1" },
    { code: "LC", name: "Saint Lucia", flag: "https://flagcdn.com/lc.svg", dialCode: "+1" },
    { code: "VC", name: "Saint Vincent and the Grenadines", flag: "https://flagcdn.com/vc.svg", dialCode: "+1" },
    { code: "WS", name: "Samoa", flag: "https://flagcdn.com/ws.svg", dialCode: "+685" },
    { code: "SM", name: "San Marino", flag: "https://flagcdn.com/sm.svg", dialCode: "+378" },
    { code: "ST", name: "Sao Tome and Principe", flag: "https://flagcdn.com/st.svg", dialCode: "+239" },
    { code: "SA", name: "Saudi Arabia", flag: "https://flagcdn.com/sa.svg", dialCode: "+966" },
    { code: "SN", name: "Senegal", flag: "https://flagcdn.com/sn.svg", dialCode: "+221" },
    { code: "RS", name: "Serbia", flag: "https://flagcdn.com/rs.svg", dialCode: "+381" },
    { code: "SC", name: "Seychelles", flag: "https://flagcdn.com/sc.svg", dialCode: "+248" },
    { code: "SL", name: "Sierra Leone", flag: "https://flagcdn.com/sl.svg", dialCode: "+232" },
    { code: "SG", name: "Singapore", flag: "https://flagcdn.com/sg.svg", dialCode: "+65" },
    { code: "SK", name: "Slovakia", flag: "https://flagcdn.com/sk.svg", dialCode: "+421" },
    { code: "SI", name: "Slovenia", flag: "https://flagcdn.com/si.svg", dialCode: "+386" },
    { code: "SB", name: "Solomon Islands", flag: "https://flagcdn.com/sb.svg", dialCode: "+677" },
    { code: "SO", name: "Somalia", flag: "https://flagcdn.com/so.svg", dialCode: "+252" },
    { code: "ZA", name: "South Africa", flag: "https://flagcdn.com/za.svg", dialCode: "+27" },
    { code: "SS", name: "South Sudan", flag: "https://flagcdn.com/ss.svg", dialCode: "+211" },
    { code: "ES", name: "Spain", flag: "https://flagcdn.com/es.svg", dialCode: "+34" },
    { code: "LK", name: "Sri Lanka", flag: "https://flagcdn.com/lk.svg", dialCode: "+94" },
    { code: "SD", name: "Sudan", flag: "https://flagcdn.com/sd.svg", dialCode: "+249" },
    { code: "SR", name: "Suriname", flag: "https://flagcdn.com/sr.svg", dialCode: "+597" },
    { code: "SE", name: "Sweden", flag: "https://flagcdn.com/se.svg", dialCode: "+46" },
    { code: "CH", name: "Switzerland", flag: "https://flagcdn.com/ch.svg", dialCode: "+41" },
    { code: "SY", name: "Syria", flag: "https://flagcdn.com/sy.svg", dialCode: "+963" },
    { code: "TW", name: "Taiwan", flag: "https://flagcdn.com/tw.svg", dialCode: "+886" },
    { code: "TJ", name: "Tajikistan", flag: "https://flagcdn.com/tj.svg", dialCode: "+992" },
    { code: "TZ", name: "Tanzania", flag: "https://flagcdn.com/tz.svg", dialCode: "+255" },
    { code: "TH", name: "Thailand", flag: "https://flagcdn.com/th.svg", dialCode: "+66" },
    { code: "TL", name: "Timor-Leste", flag: "https://flagcdn.com/tl.svg", dialCode: "+670" },
    { code: "TG", name: "Togo", flag: "https://flagcdn.com/tg.svg", dialCode: "+228" },
    { code: "TO", name: "Tonga", flag: "https://flagcdn.com/to.svg", dialCode: "+676" },
    { code: "TT", name: "Trinidad and Tobago", flag: "https://flagcdn.com/tt.svg", dialCode: "+1" },
    { code: "TN", name: "Tunisia", flag: "https://flagcdn.com/tn.svg", dialCode: "+216" },
    { code: "TR", name: "Turkey", flag: "https://flagcdn.com/tr.svg", dialCode: "+90" },
    { code: "TM", name: "Turkmenistan", flag: "https://flagcdn.com/tm.svg", dialCode: "+993" },
    { code: "TV", name: "Tuvalu", flag: "https://flagcdn.com/tv.svg", dialCode: "+688" },
    { code: "UG", name: "Uganda", flag: "https://flagcdn.com/ug.svg", dialCode: "+256" },
    { code: "UA", name: "Ukraine", flag: "https://flagcdn.com/ua.svg", dialCode: "+380" },
    { code: "AE", name: "United Arab Emirates", flag: "https://flagcdn.com/ae.svg", dialCode: "+971" },
    { code: "GB", name: "United Kingdom", flag: "https://flagcdn.com/gb.svg", dialCode: "+44" },
    { code: "US", name: "United States", flag: "https://flagcdn.com/us.svg", dialCode: "+1" },
    { code: "UY", name: "Uruguay", flag: "https://flagcdn.com/uy.svg", dialCode: "+598" },
    { code: "UZ", name: "Uzbekistan", flag: "https://flagcdn.com/uz.svg", dialCode: "+998" },
    { code: "VU", name: "Vanuatu", flag: "https://flagcdn.com/vu.svg", dialCode: "+678" },
    { code: "VA", name: "Vatican City", flag: "https://flagcdn.com/va.svg", dialCode: "+379" },
    { code: "VE", name: "Venezuela", flag: "https://flagcdn.com/ve.svg", dialCode: "+58" },
    { code: "VN", name: "Vietnam", flag: "https://flagcdn.com/vn.svg", dialCode: "+84" },
    { code: "YE", name: "Yemen", flag: "https://flagcdn.com/ye.svg", dialCode: "+967" },
    { code: "ZM", name: "Zambia", flag: "https://flagcdn.com/zm.svg", dialCode: "+260" },
    { code: "ZW", name: "Zimbabwe", flag: "https://flagcdn.com/zw.svg", dialCode: "+263" }
  ];

  // Get referral ID from URL and fetch sponsor details
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const refParam = urlParams.get('ref');
    
    if (refParam) {
      setFormData(prev => ({ ...prev, referralId: refParam }));
      fetchSponsorDetails(refParam);
    }
  }, []);

  const fetchSponsorDetails = async (userId) => {
    setIsLoadingSponsor(true);
    try {
      const response = await fetch('https://api.mbsmartweb.com/api/userdetails', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ userId: userId })
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        setSponsorDetails(null);
      } else {
        setSponsorDetails(data);
      }
    } catch (error) {
      console.error("Error fetching sponsor details:", error);
      setSponsorDetails(null);
    } finally {
      setIsLoadingSponsor(false);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsCountryDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
    setApiError("");
    
    // If referral ID changes, fetch new sponsor details
    if (name === 'referralId' && value.length >= 3) {
      fetchSponsorDetails(value);
    } else if (name === 'referralId' && value === '') {
      setSponsorDetails(null);
    }
  };

  const selectCountry = (country) => {
    setFormData({ ...formData, country: country.name });
    setIsCountryDropdownOpen(false);
    setSearchTerm("");
    if (errors.country) {
      setErrors({ ...errors, country: "" });
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.mobileNumber) {
      newErrors.mobileNumber = "Mobile number is required";
    } else if (!/^[0-9]{10,15}$/.test(formData.mobileNumber)) {
      newErrors.mobileNumber = "Enter a valid mobile number";
    }
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "Please confirm your password";
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }
    if (!formData.country || formData.country === "") {
      newErrors.country = "Please select a country";
    }
    if (!agreeTerms) newErrors.terms = "You must agree to the terms and conditions";
    return newErrors;
  };

  const copyReferralLink = () => {
    const referralLink = `${window.location.origin}/register?ref=${registeredUser.generatedUserId}`;
    navigator.clipboard.writeText(referralLink);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 3000);
  };

  const closeModal = () => {
    setShowSuccessModal(false);
    setRegisteredUser(null);
    // Redirect to login page after modal closes
    window.location.href = "/login";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    
    if (Object.keys(newErrors).length === 0) {
      setIsLoading(true);
      setApiError("");
      
      // Get country code from selected country
      const selectedCountry = countries.find(c => c.name === formData.country);
      const countryCode = selectedCountry ? selectedCountry.dialCode : "";
      
      // Prepare data matching your API exactly
      const requestData = {
        mobile: formData.mobileNumber,      // API expects 'mobile'
        sponserid: formData.referralId || "",
        password: formData.password,
        fullname: formData.name,
        email: formData.email,
        countryCode: countryCode
      };
      
      console.log("Sending to API:", requestData);
      
      try {
        const response = await fetch('https://api.mbsmartweb.com/api/createaccount3', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData)
        });
        
        const data = await response.json();
        console.log("API Response:", data);
        
        if (data.status === 1) {
          // Registration successful - use the generated userid from API response
          setRegisteredUser({
            userId: formData.mobileNumber,
            generatedUserId: data.userid,  // The LNxxxxx ID generated by backend
            name: formData.name,
            email: formData.email,
            mobile: formData.mobileNumber,
            referralId: formData.referralId || "LN100000"
          });
          setShowSuccessModal(true);
          
          // Reset form
          setFormData({
            referralId: "",
            name: "",
            mobileNumber: "",
            email: "",
            password: "",
            confirmPassword: "",
            country: ""
          });
          setAgreeTerms(false);
          setSearchTerm("");
          setSponsorDetails(null);
        } else {
          // Show error message from API
          setApiError(data.message || "Registration failed. Please try again.");
        }
      } catch (error) {
        console.error("Registration error:", error);
        setApiError("Network error. Please check your connection and try again.");
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(newErrors);
    }
  };

  const getSelectedCountryDisplay = () => {
    const selected = countries.find(c => c.name === formData.country);
    if (selected) {
      return (
        <>
          <img src={selected.flag} alt={selected.name} className="country-flag-img" />
          <span>{selected.name} ({selected.dialCode})</span>
        </>
      );
    }
    return <span className="placeholder">-- Select Country --</span>;
  };

  const filteredCountries = countries.filter(country =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="auth-container">
      <div className="auth-card register-card">
        <div className="auth-header">
          <img src={logo} alt="LogicraNetwork" className="auth-logo" />
          <h2 className="auth-title">Sign up to your new account</h2>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="referralId">Referral ID (Optional)</label>
            <div className="input-wrapper">
              <i className="fa fa-code"></i>
              <input
                type="text"
                id="referralId"
                name="referralId"
                placeholder="Enter referral ID (optional)"
                value={formData.referralId}
                onChange={handleChange}
              />
            </div>
            {isLoadingSponsor && <span className="loading-text">Checking sponsor...</span>}
            {sponsorDetails && !isLoadingSponsor && (
              <div className="sponsor-info">
                <i className="fa fa-user-circle"></i>
                <span>Referred by: <strong>{sponsorDetails.name}</strong></span>
              </div>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="name">Full Name *</label>
            <div className="input-wrapper">
              <i className="fa fa-user"></i>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Enter your full name"
                value={formData.name}
                onChange={handleChange}
                className={errors.name ? "error" : ""}
              />
            </div>
            {errors.name && <span className="error-message">{errors.name}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="mobileNumber">Mobile Number *</label>
            <div className="input-wrapper">
              <i className="fa fa-phone"></i>
              <input
                type="tel"
                id="mobileNumber"
                name="mobileNumber"
                placeholder="Enter your mobile number"
                value={formData.mobileNumber}
                onChange={handleChange}
                className={errors.mobileNumber ? "error" : ""}
              />
            </div>
            {errors.mobileNumber && <span className="error-message">{errors.mobileNumber}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address *</label>
            <div className="input-wrapper">
              <i className="fa fa-envelope"></i>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Enter your email address"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? "error" : ""}
              />
            </div>
            {errors.email && <span className="error-message">{errors.email}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="password">Password *</label>
            <div className="input-wrapper">
              <i className="fa fa-lock"></i>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                placeholder="Create a password (min 6 characters)"
                value={formData.password}
                onChange={handleChange}
                className={errors.password ? "error" : ""}
              />
              <i 
                className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} password-toggle`}
                onClick={() => setShowPassword(!showPassword)}
              ></i>
            </div>
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Confirm Password *</label>
            <div className="input-wrapper">
              <i className="fa fa-lock"></i>
              <input
                type={showConfirmPassword ? "text" : "password"}
                id="confirmPassword"
                name="confirmPassword"
                placeholder="Confirm your password"
                value={formData.confirmPassword}
                onChange={handleChange}
                className={errors.confirmPassword ? "error" : ""}
              />
              <i 
                className={`fa ${showConfirmPassword ? "fa-eye-slash" : "fa-eye"} password-toggle`}
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              ></i>
            </div>
            {errors.confirmPassword && <span className="error-message">{errors.confirmPassword}</span>}
          </div>

          {/* Custom Country Dropdown with Flag Images */}
          <div className="form-group">
            <label htmlFor="country">Select Country *</label>
            <div className="custom-dropdown" ref={dropdownRef}>
              <div 
                className={`dropdown-header ${errors.country ? "error" : ""}`}
                onClick={() => setIsCountryDropdownOpen(!isCountryDropdownOpen)}
              >
                <i className="fa fa-globe"></i>
                <div className="selected-country">
                  {getSelectedCountryDisplay()}
                </div>
                <i className={`fa fa-chevron-${isCountryDropdownOpen ? "up" : "down"} dropdown-arrow`}></i>
              </div>
              {isCountryDropdownOpen && (
                <div className="dropdown-list">
                  <div className="dropdown-search-wrapper">
                    <i className="fa fa-search"></i>
                    <input
                      type="text"
                      className="dropdown-search"
                      placeholder="Search country..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </div>
                  <div className="dropdown-options">
                    {filteredCountries.map((country) => (
                      <div
                        key={country.code}
                        className="dropdown-option"
                        onClick={() => selectCountry(country)}
                      >
                        <img src={country.flag} alt={country.name} className="country-flag-img" />
                        <span className="country-name">{country.name}</span>
                        <span className="country-dial">{country.dialCode}</span>
                      </div>
                    ))}
                    {filteredCountries.length === 0 && (
                      <div className="no-results">No countries found</div>
                    )}
                  </div>
                </div>
              )}
            </div>
            {errors.country && <span className="error-message">{errors.country}</span>}
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={agreeTerms}
                onChange={(e) => setAgreeTerms(e.target.checked)}
              />
              <span>I agree to the <a href="/terms">Terms & Conditions</a> and <a href="/privacy">Privacy Policy</a> *</span>
            </label>
            {errors.terms && <span className="error-message">{errors.terms}</span>}
          </div>

          {apiError && (
            <div className="error-message" style={{ textAlign: "center", backgroundColor: "#fee", padding: "10px", borderRadius: "8px" }}>
              {apiError}
            </div>
          )}

          <button type="submit" className="auth-btn" disabled={isLoading}>
            {isLoading ? "REGISTERING..." : "REGISTER NOW"}
          </button>

          <div className="auth-footer">
            Already have an account? <a href="/login">Login Here</a>
          </div>
        </form>
      </div>

      {/* Success Modal with Referral Link */}
      {showSuccessModal && registeredUser && (
        <div className="modal-overlay">
          <div className="success-modal">
            <div className="modal-header" style={{ background: "linear-gradient(338deg, #499df1 0%, #e9ecef 100%)" }}>
              <h3>🎉 Registration Successful!</h3>
              <button className="modal-close" onClick={closeModal}>×</button>
            </div>
            <div className="modal-body">
              <p>Welcome <strong>{registeredUser.name}</strong>!</p>
              <p>Your account has been created successfully.</p>
              
              <div className="user-details">
                <div className="detail-item">
                  <span className="detail-label">User ID:</span>
                  <span className="detail-value">{registeredUser.generatedUserId}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Email:</span>
                  <span className="detail-value">{registeredUser.email}</span>
                </div>
                <div className="detail-item">
                  <span className="detail-label">Mobile:</span>
                  <span className="detail-value">{registeredUser.mobile}</span>
                </div>
              </div>

              <div className="referral-section">
                <label>Your Referral Link:</label>
                <div className="referral-link-container">
                  <input 
                    type="text" 
                    readOnly 
                    value={`${window.location.origin}/register?ref=${registeredUser.generatedUserId}`}
                    className="referral-link-input"
                    id="referralLink"
                  />
                  <button 
                    className="copy-btn"
                    onClick={copyReferralLink}
                  >
                    <i className="fa fa-copy"></i> {copySuccess ? "Copied!" : "Copy"}
                  </button>
                </div>
                <p className="referral-note">
                  Share this link with friends and earn rewards when they join!
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button onClick={closeModal} className="modal-btn">
                Go to Login
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Register;